export default __webpack_public_path__ + "static/media/640_business04-jp-web.e231c381.png";